import { ProductInterface } from '../../../../services/exports/Interfaces';
import { IProductOffer } from '../../types';
import { useTranslation } from 'react-i18next';
import useAppMethods from '../../../../hooks/utility/useAppMethods';

const useAmountOffByProducts: IProductOffer = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });
  const { formatCurrency } = useAppMethods();

  return (offer) => {
    const isEligible = (item: ProductInterface) => offer.details.products.includes(item.id);
    const amount = offer?.details?.amount && formatCurrency(offer?.details?.amount);
    const badge = offer && t(offer.kind, { amount });

    return { isEligible, badge };
  };
};

export default useAmountOffByProducts;
